// user.js
const state = {
    webUrl: "enower.com",
    obj: {
        webUrl: "",
        webIcp: "",
        email: "",
        phone: "",
        msg: "",
        webTitle: ""
    },
    webObj: [
        {
            webTitle: "万库易采",
            icon: "/favicon.ico",
            webUrl: "enower.com",
            logoUrl: "./logo-2-dark.png",
            headerLogoUrl: "./logo.png",
            webIcp: "浙ICP备2023033145号-5",
            email: "server@enower.com",
            phone: "400-840-8088",
            msg: "2016-2025©万库易采",
            keFu: "./images/zhilidao_kefu.png",
            tel: "400-840-8088",
            // 短信模板ID
            tplId: "259853",
            accountName: "杭州浙礼道电子商务有限公司",
            openingBank: "中国银行杭州德迦支行",
            account: "392278064364"
        }
    ]
};

const mutations = {
    SET_WEBICP(state, payload) {
        state.obj = payload;
        document.title = payload.webTitle;
    },
    SET_ICON(state, payload) {
        const link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'icon';
        link.href = payload.icon;
        const head = document.head || document.getElementsByTagName('head')[0];
        const oldFavicons = document.querySelectorAll('link[rel="icon"]');
        oldFavicons.forEach(oldFavicon => head.removeChild(oldFavicon));
        head.appendChild(link);
    }
};

const actions = {
    /**
     * 设置webIcp
     */
    setWebIcp({commit}, amount) {
        commit('SET_WEBICP', amount)
        commit('SET_ICON', amount)
    },
    setIcon({commit}, amount) {
        commit('SET_ICON', amount)
    }
};

const getters = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
